import { useApi } from "../hooks/useApi";
import type { OncallResponse } from "../api/types";

export function OncallWidget() {
  const { data } = useApi<OncallResponse>("/command-center/oncall");
  if (!data || data.status !== "ok" || !data.schedules?.length) return null;
  return (
    <div className="oncall-widget visible">
      <div className="oncall-eyebrow">On-call right now</div>
      {data.schedules.slice(0, 4).map((s) => (
        <div key={s.schedule_id} className="oncall-row">
          <div>
            <div className="oncall-name">{s.current_user || "—"}</div>
            <div className="oncall-team">{s.schedule}</div>
          </div>
          {s.html_url && (
            <a href={s.html_url} target="_blank" rel="noopener" className="oncall-team">PD ↗</a>
          )}
        </div>
      ))}
    </div>
  );
}
